import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackStockReturnOrderList from '../entities/back-stockreturnorder'
import UpdateBackAbroadOrderStatu from '@/store/entities/back-order-update-statu'

interface BackStockReturnOrderState extends ListState<BackStockReturnOrderList> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

class BackAbroadOrderMutations extends ListMutations<BackStockReturnOrderList>{

}
class BackAbroadOrder extends ListModule<BackStockReturnOrderState, any, BackStockReturnOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackStockReturnOrderList>(),
        loading: false,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackStockReturnOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/AbroadStockReturn/GetAbroadReturnOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackStockReturnOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async comfirmDestroyOrder(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/AbroadStockReturn/ComfirmDestroyOrder?orderReturnId=' + payload.data.orderReturnId + '&integralNumber=' + payload.data.integralNumber);
        },
    };
    mutations = {
        setCurrentPage(state: BackStockReturnOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackStockReturnOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backstockreturnorders = new BackAbroadOrder();
export default backstockreturnorders;